
import EoButton from '../EoButton/EoButton.vue'
import EoIcon from '../EoIcon/EoIcon.vue'

export default {
  name: 'EoTwitter',
  components: { EoButton, EoIcon },
  props: {
    /**
     * Url (or id) of the tweet
     */
    url: {
      type: String,
      default: '',
    },
    /**
     * Are cookies enabled and allowed by the user?
     */
    cookiesAllowed: {
      type: Boolean,
      default: false,
    },
    /**
     * Fixed width (between 250px and 550px)
     */
    width: {
      type: [String, Number],
      default: null,
      validator: (value) => {
        if (value) {
          return 250 <= Number(value?.replace('px', '')) && Number(value?.replace('px', '')) <= 550
        }
        return true
      },
    },
  },
  data() {
    return {
      scriptSrc: 'https://platform.twitter.com/widgets.js',
      embedElementId: '',
    }
  },
  computed: {
    styles() {
      return {
        width: this.width && String(this.width)?.replace('px', '') + 'px',
      }
    },
    tweetId() {
      return this.url?.substring(this.url?.lastIndexOf('/') + 1) || this.url
    },
  },
  watch: {
    url: 'createEmbed',
    cookiesAllowed: 'initiate',
  },
  mounted() {
    this.embedElementId = `twitter-embed-${this._uid}`
    this.initiate()
  },
  beforeDestroy() {
    this.$script.unload(this.scriptSrc)
  },
  methods: {
    async initiate() {
      if (!this.cookiesAllowed) return
      this.$script.load(this.scriptSrc).then(() => {
        this.createEmbed()
      })
    },
    async createEmbed() {
      if (!window.twttr) return
      if (!this.$refs.embed) return
      this.$refs.embed.innerHTML = ''

      // https://developer.twitter.com/en/docs/twitter-for-websites/embedded-tweets/guides/embedded-tweet-parameter-reference
      window.twttr.widgets.createTweet(
        this.tweetId,
        this.$refs.embed,
        {
          conversation: 'all',
          theme: 'light',
          lang: 'nl',
          dnt: true,
          width: this.width?.replace('px', ''),
        })
    },
  },
}
